import Sortable from 'sortablejs';
import SortableController from './sortable_controller';

export default class extends SortableController {
  #axisLockFrame;

  _onStartDragging(event) {
    this.#axisLockFrame = requestAnimationFrame(() => this.#lockGhostToVerticalAxis());
  }

  _onEndDragging(event) {
    cancelAnimationFrame(this.#axisLockFrame);
  }

  // Sortable clears its active instance once the drop finishes, which stops this loop even
  // if a subclass overrides _onEndDragging without calling me.
  #lockGhostToVerticalAxis() {
    if (!Sortable.active) {
      return;
    }

    const ghost = Sortable.ghost;

    if (ghost) {
      const transform = new DOMMatrix(getComputedStyle(ghost).transform);
      transform.e = 0;
      ghost.style.transform = transform.toString();
    }

    this.#axisLockFrame = requestAnimationFrame(() => this.#lockGhostToVerticalAxis());
  }
}
